<template>


  <div v-show="stage === 1">
    <CommonForm id="task-main-form" :structure="mainFormRows" :data="taskMainContent"
                @onSubmit="saveMainDataAndGoFurther($event)"
                submitButtonText="Dalej" submitButtonEnabled="true"/>
  </div>
  <div v-show="stage === 2">
    <CommonForm id="task-drugstores-form" :structure="drugstoreFormRows" :data="taskDrugstoresIdsContent"
                @onSubmit="saveDrugstoreDataAndGoFurther($event)" submitButtonText="Dalej" submitButtonEnabled="true">
      <template v-slot:drugstoresClientIds>
        <button class="btn btn-primary" @click="showDrugstoresSelectList = true">Dodaj apteki</button>
        <div v-if="refreshFlag" class="row">
          <CommonTable2
              :table="taskDrugstoresTableData"
              rowIdentifier="drugstoreClientId"
              @onItemAction="runTableAction($event)"
              @onMassAction="runMassAction($event)"
              :sortColumn="sortingKey"
              :sortDirection="sortingDirection"
          />

        </div>
      </template>

    </CommonForm>
  </div>

  <div v-show="stage === 3">
    <CommonForm id="task-product-list-source-form" :structure="productListSourceFormRows"
                :data="taskProductListSourceContent"
                @onSubmit="saveForm($event)" submitButtonText="Zapisz" :submitButtonEnabled="commonModule.centralInstance"/>
  </div>

  <div class="price-strategy-form-back-btn" v-if="stage > 1">
    <b-button variant="light" @click="goBack()">
      <i
          class="bx bx-arrow-back"
      ></i>
      Wstecz
    </b-button>

  </div>

  <DrugstoreListModal
      :showModal="showDrugstoresSelectList"
      @update:showModal="showDrugstoresSelectList = $event"
      title="Dostępne apteki" @onApply="addDrugstores($event)" :multiselect="true"
      :selectedDrugstoresData="selectedDrugstoresDataOnlyIds"/>


</template>

<script>
import {priceSourceMap, priceStrategyTaskFormFields} from "./data/priceStrategyTaskFormFields";
import CommonForm from "@/components/widgets/CommonForm.vue";
import {tasksDrugstoresListTableStructure} from "./data/tasksDrugstoresListTableStructure";
import Swal from "sweetalert2";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import {log} from "@/state/pinia/log";
import DrugstoreListModal from "@/views/DrugstoreCommonManager/DrugstoreListModal.vue";
import {usePricesManagerModule} from "@/state/pinia/pricesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";

export default {
  name: "PricesTaskForm",
  props: {taskData: Object},
  emits: ["onTaskSaved"],
  components: {DrugstoreListModal, CommonTable2, CommonForm},
  data() {
    return {
      stage: 1,
      taskToSave: {},
      showDrugstoresSelectList: false,
      taskDrugstoresTableData: {},
      taskDrugstoresTableHeaders: tasksDrugstoresListTableStructure.headers,
      taskDrugstoresTableMassActions: tasksDrugstoresListTableStructure.massActions,
      mainFormRows: priceStrategyTaskFormFields.priceStrategyTaskMainForm,
      drugstoreFormRows: priceStrategyTaskFormFields.priceStrategyTaskDrugstoreForm,
      productFormRows: priceStrategyTaskFormFields.priceStrategyTaskProductForm,
      productListSourceFormRows: priceStrategyTaskFormFields.priceStrategyTaskListSourceForm,
      taskMainEmptyContent: {
        name: "",
        active: true,
        description: "",
        type: "PRICELIST",
        changeRetailPricesDirectly: false,
        bottomMarginLimit: 0.0,
        upperMarginLimit: 100.0,
      },
      taskMainContent: {},
      taskDrugstoresIdsEmptyContent: {
        drugstoresClientIds: [],
      },
      taskDrugstoresIdsContent: {},
      taskProductListSourceEmptyContent: {
        type: null,
        sourceDocumentNotes: "",
        numberOfDaysBackwardsToCheckDocumentNotes: 0,
        filterRxProducts: false,
        filterOtcProducts: false,
        filterNfzProposalProducts: false,
        filterRecProducts: false,
        priceSourceDrugstoreClientId: "",
      },
      taskProductListSourceContent: {},
      refreshFlag: true,
    }
  },
  computed: {
    pricesModule(){
      return usePricesManagerModule();
    },

    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    selectedDrugstoresDataOnlyIds() {
      var selectedDrugstoresQuasiObjects = []

      for (const drugstoreClientId of this.taskDrugstoresIdsContent.drugstoresClientIds) {
        selectedDrugstoresQuasiObjects.push({
          drugstoreClientId: drugstoreClientId
        })
      }

      return selectedDrugstoresQuasiObjects
    },
  },
  methods: {
    addDrugstores(drugstores) {
      if (drugstores == null) {
        this.showDrugstoresSelectList = false;
        return;
      }

      for (const drugstore of drugstores) {
        const drugstoreClientId = drugstore.drugstoreClientId
        if (!this.taskDrugstoresIdsContent.drugstoresClientIds.includes(drugstoreClientId)) {
          this.taskDrugstoresIdsContent.drugstoresClientIds.push(drugstoreClientId);
        }
      }
      this.showDrugstoresSelectList = false;
      this.refreshTaskDrugstores();
    },
    runTableAction(event) {
      log.log("table action")
      log.log(event)
      if (event.action.action === "delete") {
        if (this.taskDrugstoresIdsContent.drugstoresClientIds.includes(event.itemData.drugstoreClientId)) {
          const indexOfFoundId = this.taskDrugstoresIdsContent.drugstoresClientIds.indexOf(event.itemData.drugstoreClientId)
          this.taskDrugstoresIdsContent.drugstoresClientIds.splice(indexOfFoundId, 1);
        }
      }
      this.refreshTaskDrugstores();
    },
    runMassAction(event) {
      if (event.action.action === "delete") {
        for (const item of event.itemsData) {
          const indexOfFoundId = this.taskDrugstoresIdsContent.drugstoresClientIds.indexOf(item.drugstoreClientId)
          this.taskDrugstoresIdsContent.drugstoresClientIds.splice(indexOfFoundId, 1);
        }
      }
      this.refreshTaskDrugstores();
    },
    refreshTaskDrugstores() {
      this.refreshFlag = false;
      this.commonModule.httpGetDrugstoresForClientIds({drugstoresClientIds: this.taskDrugstoresIdsContent.drugstoresClientIds}).then((response) => {
        if (response.status === 200) {
          this.taskDrugstoresTableData['data'] = response.data.payload;
          this.refreshFlag = true;
        } else {
          var errorMessage = "";
          if (response.data.message) {
            errorMessage = response.data.message;
          }
          log.log("Coś poszło nie tak: " + errorMessage);
          Swal.fire("Coś poszło nie tak!", errorMessage, "warning")
          this.refreshFlag = true;
        }
      })
          .catch((error) => {
            log.log("Wystąpił błąd!: " + error);
            Swal.fire("Wystąpił błąd!", error + "", "error")
            this.refreshFlag = true;
          });
    },
    saveMainDataAndGoFurther(resultTask) {
      for (const key of Object.keys(resultTask)) {
        this.taskToSave[key] = resultTask[key];
      }
      this.stage = 2;
    },
    saveDrugstoreDataAndGoFurther(event) {
      log.log(event)
      this.taskToSave['drugstoresClientIds'] = this.taskDrugstoresIdsContent.drugstoresClientIds
      this.stage = 3;
    },
    saveForm(resultProductListSource) {
      if (this.taskToSave['productListSource'] == null) {
        this.taskToSave['productListSource'] = {};
      }

      for (const key of Object.keys(resultProductListSource)) {
        this.taskToSave.productListSource[key] = resultProductListSource[key];
        if (key === "type") {
          this.taskToSave.productListSource[key] = priceSourceMap[resultProductListSource[key]]
        }
      }
      this.$emit("onTaskSaved", this.taskToSave);
    },
    goBack() {
      if (this.stage > 1) {
        this.stage--;
      }
    }

  },
  created() {
    if (this.taskData != null) {
      var taskDataCopy = JSON.parse(JSON.stringify(this.taskData));
      this.taskMainContent = {
        name: taskDataCopy.name,
        active: taskDataCopy.active,
        description: taskDataCopy.description,
        type: taskDataCopy.type,
        changeRetailPricesDirectly: taskDataCopy.changeRetailPricesDirectly,
        bottomMarginLimit: taskDataCopy.bottomMarginLimit,
        upperMarginLimit: taskDataCopy.upperMarginLimit,
      }

      this.taskDrugstoresIdsContent = {
        drugstoresClientIds: taskDataCopy.drugstoresClientIds,
      }

      if (taskDataCopy.productListSource == null) {
        this.taskProductListSourceContent = JSON.parse(JSON.stringify(this.taskProductListSourceEmptyContent));
        this.taskProductListSourceContent.type = Object.keys(priceSourceMap)[0];
      } else {
        this.taskProductListSourceContent = {
          type: taskDataCopy.productListSource.type,
          sourceDocumentNotes: taskDataCopy.productListSource.sourceDocumentNotes,
          numberOfDaysBackwardsToCheckDocumentNotes: taskDataCopy.productListSource.numberOfDaysBackwardsToCheckDocumentNotes,
          filterRxProducts: taskDataCopy.productListSource.filterRxProducts,
          filterOtcProducts: taskDataCopy.productListSource.filterOtcProducts,
          filterNfzProposalProducts: taskDataCopy.productListSource.filterNfzProposalProducts,
          filterRecProducts: taskDataCopy.productListSource.filterRecProducts,
          priceSourceDrugstoreClientId: taskDataCopy.productListSource.priceSourceDrugstoreClientId,
        }
      }

    } else {
      this.taskMainContent = JSON.parse(JSON.stringify(this.taskMainEmptyContent));
      this.taskDrugstoresIdsContent = JSON.parse(JSON.stringify(this.taskDrugstoresIdsEmptyContent));
      this.taskProductListSourceContent = JSON.parse(JSON.stringify(this.taskProductListSourceEmptyContent));
      this.taskProductListSourceContent.type = Object.keys(priceSourceMap)[0];
    }

    this.taskDrugstoresTableData['headers'] = this.taskDrugstoresTableHeaders;
    this.taskDrugstoresTableData['massActions'] = this.taskDrugstoresTableMassActions;
    this.refreshTaskDrugstores();

  },


}
</script>

<style scoped>
.price-strategy-form-back-btn {
  position: relative;
  margin-left: 4px;
}
</style>
